import { useCommonStore } from '../../stores/commonStore';
import { useOpsStore } from '../../stores/opsStore';

interface HotspotFlyoutRightProps {
    children: React.ReactElement;
    onClose?: () => void;
}

export default ({ children, onClose }: HotspotFlyoutRightProps) => {
    const open: boolean = useCommonStore((state) => state.flyoutRightOpen);
    const setFlyoutRightOpen = useCommonStore((state) => state.setFlyoutRightOpen);
    const setActiveHotspot = useCommonStore((state) => state.setActiveHostpot);
    const setClearHotspotData = useCommonStore((state) => state.setClearHotspotConfig);
    const setHotspotEditMode = useOpsStore((state) => state.setHotspotEditMode);
    const handleClose = () => {
        setFlyoutRightOpen(!open);
        setClearHotspotData(true);
        setActiveHotspot('');
        if (onClose) {
            onClose();
            setHotspotEditMode(false);
        }
    };

    return (
        <div className={`bg-white shadow-sm transition-all duration-300 absolute top-16 right-0 bottom-0 z-20 w-1/3`} style={{ transform: `${open ? 'translateX(0%)' : 'translateX(100%)'}` }}>
            <div className="h-full relative">
                <div
                    className={`p-2 rounded-full shadow-md absolute -left-5 top-6 bg-white flex items-center justify-center transition-all cursor-pointer ${open ? 'opacity-100' : 'opacity-0'} pointer-events-auto`}
                    onClick={handleClose}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.3007 5.70997C17.9107 5.31997 17.2807 5.31997 16.8907 5.70997L12.0007 10.59L7.1107 5.69997C6.7207 5.30997 6.0907 5.30997 5.7007 5.69997C5.3107 6.08997 5.3107 6.71997 5.7007 7.10997L10.5907 12L5.7007 16.89C5.3107 17.28 5.3107 17.91 5.7007 18.3C6.0907 18.69 6.7207 18.69 7.1107 18.3L12.0007 13.41L16.8907 18.3C17.2807 18.69 17.9107 18.69 18.3007 18.3C18.6907 17.91 18.6907 17.28 18.3007 16.89L13.4107 12L18.3007 7.10997C18.6807 6.72997 18.6807 6.08997 18.3007 5.70997Z" />
                    </svg>
                </div>
                <div className="overflow-scroll absolute left-0 right-0 top-0 bottom-0">{children}</div>
            </div>
        </div>
    );
};
